import './Popup.css';
 
const Popup = (props:any) => {
  return (
    <div className="popup-box">
      <div className="box">
        <span className="close-icon">x</span>
        <div className="error-content my-7 text-center text-md px-5 md:px-10">{props.content}</div>
        <div className="error-btn flex justify-center px-5 md:px-10">
            <button onClick={props.handleClose} className="w-full text-white text-center bg-red-500 border-0 py-2 px-8 focus:outline-none hover:bg-red-600 rounded text-md">OK</button>
        </div>
      </div>
    </div>
  );
};
 
export default Popup;